import { filter } from 'lodash';

import { getErrorMessage } from 'application/util/error.util';
import { isCategoryListable } from 'application/util/category.util';

import './category-merge-modal.style.sass';
import template from './category-merge-modal.tpl.pug';

class CategoryMergeModalController {
    /* @ngInject */
    constructor($q, categoryService, modalService, notificationService) {
        this.$q = $q;
        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.fallbackCategory = null;

        return this.categoryService.getAll(this.teamId).then((categories) => {
            this.categories = filter(categories || [], (category) => {
                return isCategoryListable(category) && `${category.id}` !== `${this.category.id}`;
            });
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load categories. Please try again later.`));
            this.categories = [];
        });
    }

    pickFallbackCategory() {
        return this.modalService.open({
            component: 'dbACategorySelectModal',
            bindings: {
                teamId: this.teamId,
                selectedCategoryId: this.fallbackCategory && this.fallbackCategory.id,
                canAdd: false
            }
        }).then((selectedCategory) => {
            if (!selectedCategory || !selectedCategory.id) {
                return this.$q.reject();
            }

            if (`${selectedCategory.id}` === `${this.category.id}`) {
                this.notificationService.showError('Select a different fallback category.');
                return this.$q.reject();
            }

            this.fallbackCategory = selectedCategory;
            return selectedCategory;
        }).catch(() => null);
    }

    merge() {
        if (!this.fallbackCategory || !this.fallbackCategory.id) {
            return this.$q.reject();
        }

        return this.onClose({
            data: this.fallbackCategory
        });
    }

    dismiss() {
        this.onDismiss();
    }
}

export default {
    selector: 'dbACategoryMergeModal',
    template: template(),
    controller: CategoryMergeModalController,
    bindings: {
        teamId: '<',
        category: '<',
        onClose: '&',
        onDismiss: '&'
    }
};




// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-merge-modal/category-merge-modal.cmpt.js